<app-communicationFNS-simple
[uid]="getUid()"
[parentForm]="parentForm"

[disabled]="disabled"
[communication]="fnSimpleInitial.communication"
></app-communicationFNS-simple>